<template>
  <div class="security-indicator">
    <p class="text-sm add-margin-bottom">
      {{ $t('password.hint') }}
    </p>
    <div class="security-indicator__bar">
      <div
        :style="progressBarStyle"
        class="security-indicator__progress-bar"
      />
    </div>
    <div class="security-indicator__label">
      {{ label }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'SecurityIndicator',
  props: {
    percent: {
      type: Number,
      required: true,
      validator: value => value >= 0 && value <= 100
    }
  },
  computed: {
    steps () {
      return [
        { percent: 0, label: this.$t('password.indicator.percent_0'), color: 'red' },
        { percent: 25, label: this.$t('password.indicator.percent_25'), color: 'red' },
        { percent: 50, label: this.$t('password.indicator.percent_50'), color: 'red' },
        { percent: 75, label: this.$t('password.indicator.percent_75'), color: 'orange' },
        { percent: 100, label: this.$t('password.indicator.percent_100'), color: 'green' }
      ]
    },
    match () {
      let match
      this.steps.forEach(step => {
        if (step.percent <= this.percent) {
          match = step
        }
      })
      return match
    },
    label () {
      return this.match.label
    },
    color () {
      return this.match.color
    },
    progressBarStyle () {
      return {
        backgroundColor: this.color,
        width: `${this.percent}%`
      }
    }
  }
}
</script>

<style lang="sass">
.security-indicator
  margin-top: 15px

.security-indicator__bar,
.security-indicator__progress-bar
  border-radius: 3px
  height: 10px

.security-indicator__bar
  background-color: #ddd
  width: 100%

.security-indicator__progress-bar
  transition: width 200ms ease-out

</style>



// WEBPACK FOOTER //
// src/components/forms/SecurityIndicator.vue